export const Regex = {
  whiteSpace: /\s/g,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{8,}$/,
  email: /^[a-z][a-z0-9_\.]{5,32}@[a-z0-9]{2,}(\.[a-z0-9]{2,4}){1,2}$/,
  nonNumber: /[^0-9]/g,
  characterOnly: /^[a-zA-Z0-9][a-zA-Z0-9]+[a-zA-Z0-9]$/g
};
